import React, { useState } from "react";
import AnimateHeight from "react-animate-height";
var TargetHeight = 176;
function ButtonPanel(_a) {
    var instrumentTypes = _a.items, header = _a.header, onClick = _a.onClick, onHeaderClick = _a.onHeaderClick, style = _a.style;
    var _b = useState({ height: TargetHeight }), height = _b[0], setHeight = _b[1];
    var _c = useState(true), hasViewAll = _c[0], setHasViewAlll = _c[1];
    var _d = useState(600), animate = _d[0], setAnimate = _d[1];
    var toggleViewAll = function () {
        if (height.height === TargetHeight) {
            setHeight({ height: "auto" });
        }
        else {
            setHeight({ height: TargetHeight });
        }
    };
    return (React.createElement("div", { className: "ButtonPanel", style: style },
        React.createElement("div", { className: "title-container flex" },
            React.createElement("div", { className: "title " + (onHeaderClick ? 'link' : 'no-select'), onClick: onHeaderClick }, header),
            hasViewAll && React.createElement("div", { className: "viewAll no-select", onClick: function () { return toggleViewAll(); } }, height.height === TargetHeight ? "View All" : "View Less")),
        React.createElement(AnimateHeight, { height: height.height, duration: animate, className: "AnimateHeight" },
            React.createElement("div", { className: "grid", ref: function (ref) {
                    if (ref && ref.clientHeight < TargetHeight && hasViewAll) {
                        setAnimate(0);
                        setHasViewAlll(false);
                        setHeight({ height: 'auto' });
                    }
                } }, instrumentTypes.map(function (item) {
                return (React.createElement("div", { className: "grid-child " + (item.selected ? 'selected' : ''), key: item.id, onClick: function () { return onClick(item); } },
                    React.createElement("span", { className: "no-select" }, item.name)));
            })))));
}
;
export default ButtonPanel;
//# sourceMappingURL=ButtonPanel.js.map